import React from "react";

import ConfirmDialog from "../../../shared/confirm-dialog";
import { useTrainingMigrationContext } from "./context/training-migration-provider";
import { StartTrainingSyncOrgForm } from "./start-training-sync-org-form";

export const StartTrainingSyncOrgDialog: React.FC = () => {
  const {
    syncOrgDialogOpen,
    setSyncOrgDialogOpen,
    resetSyncOrgFormState,
    handleStartSyncOrg,
  } = useTrainingMigrationContext();

  return (
    <ConfirmDialog
      title="Start Training Sync Org"
      open={syncOrgDialogOpen}
      setOpen={setSyncOrgDialogOpen}
      onConfirm={async () => {
        handleStartSyncOrg();
      }}
      width="md"
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Start"
      onCancel={() => {
        resetSyncOrgFormState();
        setSyncOrgDialogOpen(false);
      }}
      // Dismissing via the backdrop or Esc skips onCancel, so reset here too
      // to avoid reopening with stale form values.
      onClose={resetSyncOrgFormState}
    >
      <StartTrainingSyncOrgForm />
    </ConfirmDialog>
  );
};
